<template>
	<div class="Page">
        <div class="Header">
            <div class="HeaderTop">
                <img class="LogoImg" src="/static/logo.png" alt="" />
            </div>
            <div class="HeaderCont">
                <div class="HeaderLogin">
                    <div class="HeaderTit">评审专家</div>
                    <div class="HeaderItem">
                        <el-input class="Val" placeholder="账号" v-model="DataJson.username" /></el-input>
                    </div>
                    <div class="HeaderItem">
                        <el-input class="Val" placeholder="请输入密码" v-model="DataJson.password" show-password></el-input>
                    </div>
                    <div class="HeaderItem">
                        <el-input class="Val" placeholder="请输入验证码" v-model="DataJson.code"></el-input>
                        <img class="ImgCode"  :src="ImgUrl" alt="" @click="GetImgCode" />
                    </div>
                    <div class="HeaderBtn" @click="loginSuc">登录</div>
                </div>
            </div>
        </div>
        <el-dialog title="初次登录需要先修改密码" :visible.sync="PassBlon" width="85%" class="BorderRadius" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">新密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入新密码" v-model="DataJson.password" show-password></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">确认密码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入确认密码" v-model="DataJson.sucpass" show-password></el-input>
            </div>
            <div slot="footer">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SetPass">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
	export default {
		data() {
			return {
                DataJson:{
                    username:"",
                    password:"",
                    code:"",
                },
                ImgUrl:"",
                PassBlon:false,
			};
		},
        mounted() {
           this.GetImgCode();
        },
		methods: {
            loginSuc(){
                if(!this.DataJson.username){this.$message.error("请输入账号");return;}
                if( !this.DataJson.password){this.$message.error("请输入密码");return;}
                this.$post("/api/auth/login",{
                    username:this.DataJson.username,
                    password:this.DataJson.password,
                    captcha:this.DataJson.code,
                }).then(res=>{
                    if(res){
                        sessionStorage.setItem('USER-TOKEN',res.data.token);
                        if(res.data.user_info.is_dl){
                            this.$Tools.ResetData(this.DataJson);
                            this.PassBlon = true;
                        }else{
                            if(res.data.user_info.is_expert){
                                this.$Tools.localData('g',null);
                                sessionStorage.setItem('USER-Info',JSON.stringify(res.data));
                                sessionStorage.setItem('SYSTEM-TOKEN',"expert_portal");
                                setTimeout(()=>{
                                    this.$router.push({path: '/MobileSystem'});
                                },50)
                            }else{
                                this.$message.error("请登录专家账号");
                                this.$Tools.ResetData(this.DataJson);
                            }
                        }
                    }
                }).finally(error => {
                    this.GetImgCode();
                    this.DataJson.code="";
                })
            },
            GetImgCode(){
                this.$get("api/auth/captcha").then(res=>{
                    if(res){
                        this.ImgUrl = res.data.img;
                    }
                })
            },
            SetPass(){
                this.$post('/api/auth/userPass',{
                    password: "123456",
                    passwords:this.DataJson.password,
                    passwordss:this.DataJson.sucpass,
                }).then(res=>{
                    if(res){
                        this.PassBlon = false;
                        this.$message.success(res.msg);
                        this.$Tools.ResetData(this.DataJson);
                    }
                })
            },
		}
	}
</script>

<style scoped>
    .Header{
        background: #095b95;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
	.HeaderTop{
	    padding:20px;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
    }
    .LogoImg{
        width: 80%;
    }
    .HeaderCont{
        margin-top: 20vh;
    }
    .HeaderLogin{
        width: 85%;
        margin: 0 auto;
        padding: 10px;
        border-radius: 10px;
        background: #fff;
    }
    .HeaderTit{
        text-align: center;
        font-weight: 700;
        font-size: 24px;
        color: #2c2c2c;
        margin-bottom: 20px;
        padding: 15px 0;
    }
    .HeaderItem{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 20px 20px;
        position: relative;
    }
    .HeaderItem .Val{
        background: #f8f8f8;
        flex: 1;
        border: 0 solid #ddd;
    }
    .HeaderItem .ImgCode{
        width: 120px;
        /* color: #fff; */
        /* font-size: 14px; */
        text-align: center;
        /* padding: 12px 0; */
        border-radius: 5px;
    }
    .HeaderBtn{
        margin: 0 45px;
        padding: 12px 10px;
        text-align: center;
        background: #095b95;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
    }
</style>